/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component, useState, useEffect } from 'react' // eslint-disable-line

import { Drawer, Button, Form, Spin, Input, message } from 'antd'

import { machineAction } from '../../action/machine'

import { listLoader } from '../../store/list/ListLoader'
import { ViewerStyles, EditorStyles } from './styles'

const FIELDS_LIST = [
  ['uid', '用户Id'],
  ['machine_id', '机器Id'],
  ['hour', '时长'],
  ['unit', 'GPU数'],
  ['price', '价格'],
]

interface Props {
  text: string
  icon: string
  block?: boolean
}

const MachineCreateFormInner = (props: any) => {
  const formData = props.formData
  const { getFieldDecorator, setFieldsValue } = props.form

  const onSubmitCreate = (e: Event) => {
    e.preventDefault()
    props.form.validateFields((err: any, values: any) => {
      if (err) {
        console.log('Received values of form: ', values)
        return
      }
      props.onSubmit(values, (data: any) => {
        setFieldsValue(data)
      })
    })
  }

  return <Form layout="vertical" css={EditorStyles['edit-form']} onSubmit={onSubmitCreate}>
    <Form.Item label="机器编号" css={EditorStyles["edit-label-title"]}>
      <span className="ant-form-text">创建新机器</span>
    </Form.Item>
    {
      FIELDS_LIST.map((item) => {
        const key = item[0]
        return (
          <Form.Item
            key={item}
            label={
              <span css={EditorStyles['edit-label']}>
                <span className="label-title">{item[0]}:</span>
                <span css={EditorStyles['edit-label-hint']}>{item[1]}</span>
              </span>
            }
          >
            <div css={EditorStyles['edit-hint-line']}>
              {
                getFieldDecorator(key, {
                  initialValue: formData[key] || '',
                  rules: [
                    { required: true, message: `请填入正确的${item[1]}` },
                  ],
                })(
                  <Input placeholder={`Input ${key}`} />
                )
              }
            </div>
          </Form.Item>
        )
      })
    }
    <Form.Item>
      <Button icon="plus" htmlType="submit">创建</Button>
    </Form.Item>
  </Form>
}

const MachineCreateForm = Form.create({ name: 'machine_create' })(MachineCreateFormInner)

const initFormData = () => {
  return FIELDS_LIST.reduce((result: any, current) => {
    result[current[0]] = ''
    return result
  }, {})
}

export default (props: Props) => {
  const [visible, onVisibleChange] = useState(false)
  const [loading, onLoadChange] = useState(false)
  const [formData, onSetFormData] = useState<any>({})

  const onSubmitCreate = (formData: any, resetForm: any) => {
    onLoadChange(true)
    machineAction.createMachine(formData)
      .then(responseData => {
        message.info('创建机器成功')
        onLoadChange(false)
        onSetFormData({})
        resetForm(initFormData())
        listLoader.reloadListPage()
      })
      .catch((err) => {
        onLoadChange(false)
        message.warning(err.message)
      })
  }

  return (
    <div css={EditorStyles['edit-pane']}>
      <Button onClick={
        () => {
          onVisibleChange(true)
        }
      } icon={props.icon} block={props.block}>{props.text}</Button>
      <Drawer
        title="创建机器"
        width={420}
        visible={visible}
        onClose={() => {
          onVisibleChange(false)
        }}
      >
        <div css={ViewerStyles['drawer-container']}>
          <Spin spinning={loading}>
            <MachineCreateForm
              formData={formData}
              onSubmit={onSubmitCreate}
            />
          </Spin>
        </div>
      </Drawer>
    </div>
  )
}